module.exports = new __parcel__URL__("kick_11.ca60b639.mp3").toString();